export default __webpack_public_path__ + "static/media/touch.a0d361ea.gif";